import { render, staticRenderFns } from "./ChatHistoric.vue?vue&type=template&id=41f09a02"
import script from "./ChatHistoric.vue?vue&type=script&lang=js"
export * from "./ChatHistoric.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports